import React, { useState, useEffect, useRef } from "react";
import {  FieldArray, FormikProvider, Form } from "formik";
import Select, { components } from "react-select";
import InputField from "../../../../component/input-field";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import "../../../../css/theme.css";
import { useDispatch, useSelector } from "react-redux";
import { allowUploadExtension, sanitizeInput } from "../../../../utils";
import { Customer } from "../../../../constant/AuthenticationConstant";
import { getCollaboratorOrCustomer } from "../../../../redux/actions/collaboratorOrCustomer";
import { useLocation } from "react-router-dom";
import { getAllBookingByCompanyId, getAllBookingName} from "../../../../redux/actions/bookingtemplate";
import { GET_ALL_BOOKING_NAME } from "../../../../redux/constants";
import { Checkbox, DateTime, Dropdown, Link, NumberField, Paragraph, RadioButton, TextField, Toggle } from "../../../booking/CustomizedControls";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../../component/modal-popup/customeModal"; 
import Dropzone from "react-dropzone";
import { deleteBookingFile } from "../../../../redux/actions/booking";
import BookingFileViewer from "../../../../component/BookingFileViewer";
const { MenuList } = components;

function CreateSalesOrder({ formik, productOptions, newjson, setNewJson, validation, fileupload, setFileUpload, upload, setUpload, assignmentFormik, isEdited }) {
  const state = useLocation().state;

  // State
  const [customerOptions, seCustomerOptions] = useState([]);
  const [allbookingtemp, setAllBookingTemp] = useState([]);
  const [booking, setBooking] = useState("");
  const [customFieldMaxRowSize, setCustomFieldMaxRowSize] = useState();
  const { bookingTemplateArr } = useSelector((state) => state.bookingTemplate);
  const salesOrder = useSelector(state => state.salesOrder);
  const { v4: uuidv4 } = require("uuid");
  const customRowsParentDiv = useRef();
  //Redux
  const dispatch = useDispatch();
  const { allProductData } = useSelector((state) => state.productMaster);


  // Function to GET Customer list
  const getCustomer = () => {
    dispatch(
      getCollaboratorOrCustomer(Customer, (res) => {
        if (res.status === 1) {
          const users = res.data.data.map((item) => {
            return {
              value: item.collaborator_id,
              label: item.name,
            };
          });
          seCustomerOptions(users);
        }
      })
    );
  };

  useEffect(() => {
    if (bookingTemplateArr?.length !== 0) {
      bookingTemplateArr?.sort(function (a, b) {
        return a.sequence - b.sequence;
      });
    }
  }, [bookingTemplateArr]);

  useEffect(() => {
    if (bookingTemplateArr?.length > 0) {
      const lastCustomField = JSON.parse(
        bookingTemplateArr[bookingTemplateArr?.length - 1].grid_position
      );
      const highestRow = lastCustomField.y;
      setCustomFieldMaxRowSize(highestRow);
    }
  }, [bookingTemplateArr]);

  useEffect(() => {
    if (bookingTemplateArr?.length > 0 && newjson?.length === 0) {
      var arr = [];
      bookingTemplateArr?.forEach((ele) => {
        const type = ele.component?.type;
        arr.push({
          booking_template_custom_field_id:
            ele.booking_template_custom_field_id,
          component_id: ele.component_id,
          field_name: ele.component?.label,
          field_value:
            type === "toggle" || type === "check box"
              ? JSON.stringify(ele.component.is_check_by_default)
              : null,
          required: ele.is_required,
        });
      });
      setNewJson(arr);
    }
  }, [bookingTemplateArr]);

  useEffect(() => {
    getCustomer();
    dispatch(
      getAllBookingByCompanyId((res) => {
        if (res.status === 1) {
          const result = res.data;
          const arr = [];
          result.data.forEach((item) => {
            arr.push({
              value: item.booking_template_name,
              label: item.booking_template_name,
              id: item.booking_template_id,
            });
          });
          setAllBookingTemp(arr);

          if(formik.values.booking_template_id){
            const findValue = arr.find(item => item.id === formik.values.booking_template_id);
            if(findValue) {
              setBooking(findValue);
              dispatch(getAllBookingName(formik.values.booking_template_id, (res) => {}));
              // if(assignmentFormik.values.inventory_order_id){

              // }
              // dispatch(
              //   getValueByBookingTemplateId(assignmentFormik.values.inventory_order_id, (res) => {
              //     if (res.status === 1) {
              //       setNewJson(res.data.controls);
              //       setFileUpload(res.data.file_uploads)
              //     }
              //   })
              // );
            };
          }
        }
      })
    );
  }, []);

  const getProductUnit = (product_id) => {
    const product = allProductData.find(
      (item) => item.product_master_id === product_id
    );
    return product ? product?.master_uom?.master_uom_name : "";
  };

  const getBookingCustomFields = (e) => {
    setBooking(e);
    const id = e === null ? null : e.id;
    if (id !== "" && id !== null) {
      // setBookingTempId(id);
      formik.setFieldValue("booking_template_id", id)
      assignmentFormik.setFieldValue("booking_template_id", id)
      dispatch(getAllBookingName(id, (res) => {}));
    } else {
      dispatch({
        type: GET_ALL_BOOKING_NAME,
        payload: [],
      });
      // setBookingTempId(null);
      formik.setFieldValue("booking_template_id", null)
      assignmentFormik.setFieldValue("booking_template_id", id)
    }
  };

  const CustomMenuList = ({ children, ...props }) => (
    <MenuList {...props}>
      {children}
      {/* <div
        className="menu-list !text-[--bg-color-500]"
        onClick={(e) => {
          e.stopPropagation();
          handleNavigation(props.selectProps.name);
        }}
      >
        <i
          class="fa-solid fa-plus fa-xs text-[--bg-color-500]"
          style={{ paddingRight: "2px", paddingTop: "2px" }}
        ></i>
        <span className="!text-[--bg-color-500]">
          {props.selectProps.name === "bookingtemp"
            ? "Create New Booking Template"
            : props.selectProps.name === "configname"
            ? "Create New Workflow"
            : props.selectProps.name === "asset_type"
            ? "Create New Asset"
            : "Create New Customer"}
        </span>
      </div> */}
    </MenuList>
  );

  const renderInput = (input, index, validation) => {
    const isMandatory = input.is_required;
    var value;

    newjson?.forEach((ele) => {
      if (
        ele.booking_template_custom_field_id ===
        input.booking_template_custom_field_id
      ) {
        value = ele?.value ? ele.value : ele?.field_value ? ele.field_value : "";
      }
    });

    const gridPosition = JSON.parse(input.grid_position);
    const inputWidth = gridPosition?.w ? gridPosition.w : 2;
    const gridWidthClass = `${
      parseInt(inputWidth) !== 4 ? (parseInt(inputWidth) / 4) * 100 : 100
    }`;
    const props = {
      isMandatory,
      index,
      input,
      value,
      validation,
      handleChange: handleChange,
      gridWidthClass,
    };
    if (input.component?.type === "text") {
      return <TextField {...props} />;
    } else if (input.component?.type === "toggle") {
      return <Toggle {...props} />;
    } else if (input.component?.type === "radio group") {
      return <RadioButton {...props} />;
    } else if (input.component?.type === "link") {
      return <Link {...props} />;
    } else if (input.component?.type === "check box") {
      return <Checkbox {...props} />;
    } else if (input.component?.type === "dropdown") {
      return <Dropdown {...props} />;
    } else if (input.component?.type === "date/time") {
      return <DateTime {...props} />;
    } else if (input.component?.type === "paragraph") {
      return <Paragraph {...props} />;
    } else if (input.component?.type === "number") {
      return <NumberField {...props} />;
    }
  };

  const handleChange = (e, id, type) => {
    if (type === "dropdown") {
      var value = e === null ? null : e.value;
    } else if (type === "checkbox") {
      var value = JSON.stringify(e.target.checked);
    } else {
      var value = type === "datetime" ? e[0] : sanitizeInput(e.target.value);
    }
    newjson.map((ele, index) => {
      if (ele.booking_template_custom_field_id === id) {
        let copyjson = [...newjson];
        copyjson[index].field_value = value;
        setNewJson(copyjson);
      }
    });
  };


  const uploadFile = (e) => {
    for (const item of e) {
      let fileName = "";
      var filetype = item.name.split(".").pop();
      fileName = item.name;
      const type = [
        "pdf",
        "doc",
        "docx",
        "xls",
        "xlsx",
        "jpeg",
        "jpg",
        "png",
        "bmp",
        "txt",
      ];
      const maxFileSize = 4 * 1024 * 1024;
      if (item.size > maxFileSize) {
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={`${item.name} file exceeds upload limit of 4 MB.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
      if (!type.includes(filetype.toLowerCase())) {
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={`${item.name} must be among these pdf, doc, docx, xls, xlsx, jpeg, jpg, png, bmp, txt.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
      setFileUpload((prev) => [
        ...prev,
        {
          id: uuidv4(),
          file_name: fileName,
        },
      ]);
      setUpload((prev) => {
        return [...prev, item];
      });
    }
  };

  const handleFileDelete = (payload) => {
    if(payload.booking_file_upload_id){

      setFileUpload(
        fileupload.filter(
          (ele) => ele.booking_file_upload_id !== payload.booking_file_upload_id
        )
      );

      dispatch(
        deleteBookingFile(payload.booking_file_upload_id, (res) => {
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content={`Uploaded file deleted successfully`}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        })
      );

    }else if(payload.id){
      let index = fileupload.findIndex(
        (ele) => ele.id === payload.id
      );
      setFileUpload(
        fileupload.filter(
          (ele) => ele.id !== payload.id
        )
      );
      let name = fileupload[index].file_name;
      setUpload(upload.filter((ele) => ele.name !== name));
    }
  }
  

  return (
    <div className="mt-4 ">
      <div
        className="flex flex-col space-y-6 relative"
        style={{ minHeight: "calc(100vh - 180px)" }}
      >
        {/* overflow-y-auto */}
        <div className="lg:max-h-[330px] grid grid-cols-1 lg:grid-cols-2 gap-4">

          {/* Basic Details */}

          <div className="rounded-md bg-[--bg-color-50] p-4 space-y-6">
            <h4 className="text-[#535860] font-bold leading-[100%] text-base">
              Basic Details
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

              {/* First Column */}
              <div className="w-full space-y-1">
                <InputField
                  label="Sales Order Number"
                  name="sales_order_no"
                  value={state ? state?.sales_order_no : salesOrder?.headerValue ? salesOrder.headerValue : "TBA"}
                  disabled
                />

                <InputField
                  label="Delivery Address"
                  placeholder="Address Line 1"
                  required
                  name="address_line_1"
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    const value = sanitizeInput(e.target.value);
                    formik.setFieldValue("address_line_1", value);
                  }}
                  value={formik.values.address_line_1}
                  error={
                    Boolean(
                      formik.touched.address_line_1 &&
                        formik.errors.address_line_1
                    )
                      ? formik.errors.address_line_1
                      : null
                  }
                />
                <InputField
                  placeholder="Address Line 2"
                  name="address_line_2"
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    const value = sanitizeInput(e.target.value);
                    formik.setFieldValue("address_line_2", value);
                  }}
                  value={formik.values.address_line_2}
                />
                <div className="flex items-start space-x-2">
                  <InputField
                    wrapperClass="w-2/6"
                    placeholder="ZIP Code"
                    name="zip_code"
                    onBlur={formik.handleBlur}
                    onChange={(e) => {
                      const value = sanitizeInput(e.target.value);
                      formik.setFieldValue("zip_code", value);
                    }}
                    value={formik.values.zip_code}
                    error={
                      Boolean(formik.touched.zip_code && formik.errors.zip_code)
                        ? formik.errors.zip_code
                        : null
                    }
                  />
                  <InputField
                    wrapperClass="grow"
                    placeholder="City"
                    name="city"
                    onBlur={formik.handleBlur}
                    onChange={(e) => {
                      const value = sanitizeInput(e.target.value);
                      formik.setFieldValue("city", value);
                    }}
                    value={formik.values.city}
                    error={
                      Boolean(formik.touched.city && formik.errors.city)
                        ? formik.errors.city
                        : null
                    }
                  />
                </div>
                <InputField
                  placeholder="Country"
                  name="country"
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    const value = sanitizeInput(e.target.value);
                    formik.setFieldValue("country", value);
                  }}
                  value={formik.values.country}
                  error={
                    Boolean(formik.touched.country && formik.errors.country)
                      ? formik.errors.country
                      : null
                  }
                />
              </div>

              {/* Second Column */}
              <div className="space-y-1 md:space-y-4">
                <InputField
                  label="Sales Order Reference Number"
                  placeholder="Enter Sales Order Reference Number"
                  name="sales_order_reference_no"
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    const value = sanitizeInput(e.target.value);
                    formik.setFieldValue("sales_order_reference_no", value);
                  }}
                  value={
                    formik.values.sales_order_reference_no
                      ? formik.values.sales_order_reference_no
                      : ""
                  }
                />
                <div className="w-full">
                  <label
                    className={`block text-sm font-medium mb-1`}
                    htmlFor="card-city"
                  >
                    Customer&nbsp;
                    <span className="text-rose-500">*</span>
                  </label>
                  <Select
                    className="basic-single text-sm unresetText"
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        backgroundColor: "white",
                        borderColor: "lightgray",
                      }),
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                      placeholder: (provided, state) => ({
                        ...provided,
                        color: "#9297A2",
                        fontSize: "14px",
                      }),
                    }}
                    classNames={{
                      control: (style) => {
                        return `!border !shadow-sm ${
                          style.isFocused
                            ? "!border-[--bg-color-300]/50"
                            : "!border-slate-200 hover:!border-gray-300"
                        }`;
                      },
                      container: (style) => {
                        return "!h-[37.5px] !font-inter !text-sm";
                      },
                      menuList: (style) => {
                        return `!max-h-[200px]`;
                      },
                    }}
                    onChange={(collaborator) => {
                      formik.setFieldValue("collaborator_id", collaborator?.value);
                    }}
                    value={
                      formik.values.collaborator_id
                        ? customerOptions.find(
                            (element) =>
                              element.value === formik.values.collaborator_id
                          )
                        : ""
                    }
                    options={customerOptions}
                    placeholder="Select Supplier"
                  />
                  {Boolean(
                    formik.touched.collaborator_id && formik.errors.collaborator_id
                  ) && (
                    <div className="text-xs text-rose-600 pt-1 pl-1">
                      {formik.errors.collaborator_id}
                    </div>
                  )}
                </div>
              {/* <div className="space-y-4"> */}
                <div className="w-full relative">
                  <label
                    className={`block text-sm font-medium mb-1`}
                    htmlFor="card-city"
                  >
                    Estimated Dispatch Date&nbsp;
                    <span className="text-rose-500">*</span>
                  </label>
                  <Flatpickr
                    data-enable-time
                    options={{
                      altFormat: "j M, Y",
                      dateFormat: "Y-m-d",
                      time_24hr: false,
                      disableMobile: true,
                      enableTime: false,
                      altInput: true,
                      minDate: "today",
                    }}
                    name="planned_date"
                    onBlur={formik.handleBlur}
                    value={formik.values.planned_date}
                    onChange={(e) => {
                      formik.setFieldValue("planned_date", e[0]);
                    }}
                    render={({ defaultValue }, ref) => {
                      return (
                        <div className="w-full">
                          <input
                            title="Component Placeholder"
                            className="form-input w-[100%] truncate disabled:border-slate-200"
                            defaultValue={defaultValue}
                            ref={ref}
                            placeholder="Select Estimated Dispatch Date"
                          />
                          <div className="absolute inset-0 left-auto !top-8 opacity-100 group">
                            <span className="text-sm text-slate-500 font-medium px-3 ">
                              <span className="far fa-calendar text-[#1E293B] z-60 bg-white"></span>
                            </span>
                          </div>
                          {Boolean(
                            formik.touched.planned_date &&
                              formik.errors.planned_date
                          ) && (
                            <div className="text-xs text-rose-600 pt-1 pl-1">
                              {formik.errors.planned_date}
                            </div>
                          )}
                        </div>
                      );
                    }}
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Ordered SKU */}

          <div
            className="rounded-md bg-[--bg-color-50] p-4 space-y-6 overflow-y-auto scrollbar scrollbar-w-2 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100"
            style={{ height: "330px" }}
          >
            <h4 className="text-[#535860] font-bold leading-[100%] text-base">
              Ordered Products
            </h4>
            <FormikProvider value={formik}>
              <Form autoComplete="off" noValidate>
                <FieldArray
                  name="products"
                  render={(arrayHelpers) => (
                    <div className="space-y-2">
                      {formik.values.products.map((item, index) => {
                        return (
                          <div
                            key={index}
                            className="grid grid-cols-2 gap-2 relative"
                          >
                            <div className="w-full">
                              {index === 0 && (
                                <label
                                  className={`block text-sm font-medium mb-1`}
                                  htmlFor="card-city"
                                >
                                  Products&nbsp;
                                  <span className="text-rose-500">*</span>
                                </label>
                              )}

                              <Select
                                className="basic-single text-sm unresetText"
                                menuPortalTarget={document.body}
                                menuPlacement="top"
                                styles={{
                                  control: (provided) => ({
                                    ...provided,
                                    backgroundColor: "white",
                                    borderColor: "lightgray",
                                  }),
                                  menuPortal: (base) => ({
                                    ...base,
                                    zIndex: 9999,
                                  }),
                                  placeholder: (provided, state) => ({
                                    ...provided,
                                    color: "#9297A2",
                                    fontSize: "14px",
                                  }),
                                }}
                                classNames={{
                                  control: (style) => {
                                    return `!border !shadow-sm ${
                                      style.isFocused
                                        ? "!border-[--bg-color-300]/50"
                                        : "!border-slate-200 hover:!border-gray-300"
                                    }`;
                                  },
                                  container: (style) => {
                                    return "!h-[37.5px] !font-inter !text-sm";
                                  },
                                  menuList: (style) => {
                                    return `!max-h-[200px]`;
                                  },
                                }}
                                onBlur={formik.handleBlur}
                                onChange={(product) => {
                                  formik.setFieldValue(
                                    `products[${index}].product_master_id`,
                                    product?.value
                                  );
                                }}
                                value={
                                  formik.values.products[index].product_master_id
                                    ? productOptions.find(
                                        (element) =>
                                          element.value ===
                                          formik.values.products[index]
                                            .product_master_id
                                      )
                                    : ""
                                }
                                options={productOptions.filter((optionItem) => {
                                  return !formik.values.products.some(
                                    (el) =>
                                      el?.product_master_id === optionItem.value
                                  );
                                })}
                                placeholder="Select Products"
                              />
                              {Boolean(
                                formik?.touched?.products?.[index]
                                  ?.product_master_id &&
                                  formik?.errors?.products?.[index]
                                    ?.product_master_id
                              ) && (
                                <div className="text-xs text-rose-600 pt-1 pl-1">
                                  {
                                    formik?.errors?.products?.[index]
                                      ?.product_master_id
                                  }
                                </div>
                              )}
                            </div>
                            <div className="w-full flex items-center space-x-2">
                              <InputField
                                label={index === 0 && "Quantity"}
                                placeholder="Enter Quantity"
                                required
                                name="qty"
                                onBlur={formik.handleBlur}
                                onChange={(e) => {
                                  const value = sanitizeInput(e.target.value);
                                  formik.setFieldValue(
                                    `products[${index}].qty`,
                                    value
                                  );
                                }}
                                value={formik.values.products[index].qty}
                                error={
                                  Boolean(
                                    formik?.touched?.products?.[index]?.qty &&
                                      formik?.errors?.products?.[index]?.qty
                                  )
                                    ? formik?.errors?.products?.[index]?.qty
                                    : null
                                }
                                suffix={
                                  getProductUnit(
                                    formik.values.products[index]
                                      .product_master_id
                                  ) ? (
                                    getProductUnit(
                                      formik.values.products[index]
                                        .product_master_id
                                    )
                                  ) : (
                                    <span title="Delete" className="fa-solid fa-trash-can mt-6 text-rose-500 cursor-pointer invisible"></span>
                                  )
                                }
                              />
                              <div className="flex justify-start items-center">
                                {formik.values.products.length > 1 && (
                                  <span
                                    title="Delete"
                                    className={`fa-solid fa-trash-can ${
                                      index === 0 && "mt-6"
                                    } text-rose-500 cursor-pointer`}
                                    onClick={() => arrayHelpers.remove(index)}
                                  ></span>
                                )}
                              </div>
                            </div>
                          </div>
                        );
                      })}

                      <h6
                        className={`text-xs font-semibold leading-3 tracking-tight text-[--bg-color-500] cursor-pointer my-2`}
                        onClick={() => {
                          arrayHelpers.push({
                            product_master_id: "",
                            qty: "",
                          });
                        }}
                      >
                        + Add Product
                      </h6>
                    </div>
                  )}
                />
              </Form>
            </FormikProvider>
          </div>

        </div>
        <div className="flex flex-1 w-full flex-row flex-wrap md:flex-nowrap md:space-x-4 space-y-4 md:space-y-0">
          <div className="p-4 w-full md:w-9/12 rounded-md bg-[--bg-color-50]">
            <h4 className="text-[#535860] font-bold leading-[100%] text-base">
              Booking Details
            </h4>
            <div className="w-full sm:w-[300px] mt-5 rounded transition-all">
              <label for="assets" className="text-[#535860] text-sm font-medium mb-2">
                Select Booking Template
              {/* <span className="text-rose-500">*</span> */}
              </label>
              <br />
              <Select
                className="basic-single text-sm unresetText mt-1"
                classNames={{
                  option: (style) => {
                    return `${
                      style.isSelected && "!bg-[--bg-color-500] !text-white"
                    } ${style.isFocused && "!bg-[--bg-color-500] !text-white"}`;
                  },
                  control: (style) => {
                    return `!border !shadow-sm ${
                      style.isFocused
                        ? "!border-[--bg-color-300]/50"
                        : "!border-slate-200 hover:!border-gray-300"
                    }`;
                  },
                  container: (style) => {
                    return "!h-[37.5px] !font-inter !text-sm";
                  },
                  menuList: (style) => {
                    return `!max-h-[200px]`;
                  },
                }}
                isClearable={true}
                classNamePrefix="select"
                name="bookingtemp"
                options={allbookingtemp}
                value={booking}
                placeholder="Select Booking Template"
                onChange={(e) => getBookingCustomFields(e)}
                components={{ MenuList: CustomMenuList }}
                isDisabled={isEdited}
                required
              />
            </div>
            <div className="w-full mt-4">
              {customFieldMaxRowSize?.toString() &&
                bookingTemplateArr?.length > 0 && (
                  <div ref={customRowsParentDiv}>
                    {bookingTemplateArr?.map((customeComponent, index) => {
                      const filteredComponentList = bookingTemplateArr?.filter(
                        (element) => JSON.parse(element.grid_position).y === index
                      );

                      if (index <= customFieldMaxRowSize) {
                        return (
                          <div className="flex flex-wrap">
                            {filteredComponentList.map((comp, indexNumber) => {
                              return renderInput(
                                comp,
                                comp.booking_template_custom_field_id,
                                validation
                              );
                            })}
                          </div>
                        );
                      }
                    })}
                  </div>
              )}
            </div>  
          </div>
          {/* col-span-12 md:col-start-9 md:col-end-12 */}
          <div className="p-4 w-full md:w-3/12 rounded-md bg-[--bg-color-50]">
            <h4 className="text-[#535860] font-bold leading-[100%] text-base">
              Documents

              <div>
                <Dropzone
                    accept={allowUploadExtension.join(",")}
                  // accept={{
                  //   "image/*": [], // Accepts all image formats
                  // }}
                  onDrop={(acceptedFiles) => {
                    uploadFile(acceptedFiles)
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section className="mt-5 rounded-xl border-2 border-dashed border-[#94A3B8] h-[140px] flex justify-center items-center bg-slate-200">
                      <div {...getRootProps()}>
                        <input {...getInputProps()} />
                        <div className="space-y-2">
                          <>
                            <span class="fa-light fa-arrow-up-from-bracket text-2xl font-normal block text-center"></span>
                            <h4 className="text-sm text-[#94A3B8] font-medium">
                              Drop your files here or
                            </h4>
                            <div className="flex justify-center">
                              <button className="btn !h-8 !border !border-[--bg-color-500] text-[--bg-color-500] flex justify-center">
                                Browse Files
                              </button>
                            </div>
                          </>
                        </div>
                      </div>
                    </section>
                  )}
                </Dropzone>
                <div className="mt-4 space-y-1">
                  {fileupload.length > 0 && fileupload.map((item) => (
                    item?.booking_file_upload_id ? (
                      <BookingFileViewer file_name={item.file_name} file_upload_id={item.booking_file_upload_id} _handleDelete={handleFileDelete} />
                    ) : (
                      <div className="flex flex-row justify-between items-center py-1">
                        <div className="w-[80%] truncate font-inter font-bold text-[13px] text-[#535860]">
                          {item.file_name}
                        </div>
                        <div
                          title="Delete"
                          className={`fa-regular fa-trash-can text-lg text-rose-500 cursor-pointer`}
                          onClick={(e) => {
                            e.stopPropagation();
                            handleFileDelete(item)
                          }}
                        ></div>
                      </div>
                    )
                  ))}
                </div>
              </div>
            </h4>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateSalesOrder;
